"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = exports.ToastProvider = exports.useToast = exports.ToastContext = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var components_utils_1 = require("@conte-ltd/components-utils");

var overlays_1 = require("@react-stately/overlays");

var react_2 = require("react");

var drawer_1 = require("./drawer");

var overlay_container_1 = require("./overlay-container");

exports.ToastContext = (0, react_2.createContext)(null);

function useToast(props) {
  var context = (0, react_2.useContext)(exports.ToastContext);
  (0, components_utils_1.assertIsDefined)(context, 'useToastはToastProviderコンポーネントの配下で使用する必要があります');
  var render = context.render,
      setArgs = context.setArgs;
  var notify = (0, react_2.useCallback)(function (message, options) {
    setArgs([message, __assign(__assign({}, props), options)]);
  }, [setArgs, props]);
  return {
    notify: notify,
    render: render
  };
}

exports.useToast = useToast;

function ToastProvider(props) {
  var children = props.children,
      render = props.render;
  var renderer = render !== null && render !== void 0 ? render : function (message, options) {
    return (0, jsx_runtime_1.jsx)(exports.Toast, __assign({
      role: 'dialog'
    }, options, {
      children: message
    }), void 0);
  };

  var _a = __read((0, react_2.useState)(null), 2),
      args = _a[0],
      setArgs = _a[1];

  var Render = function Render(_a) {
    var renderer = _a.renderer,
        args = _a.args;
    var state = (0, overlays_1.useOverlayTriggerState)(props);
    (0, react_2.useEffect)(function () {
      state.open();
    }, []);
    return (0, jsx_runtime_1.jsx)(overlay_container_1.OverlayContainer, __assign({
      isOpen: state.isOpen,
      onClose: state.close,
      isAutoClose: true
    }, {
      children: args && renderer.apply(void 0, __spreadArray([], __read(args), false))
    }), void 0);
  };

  return (0, jsx_runtime_1.jsxs)(exports.ToastContext.Provider, __assign({
    value: {
      render: renderer,
      setArgs: setArgs
    }
  }, {
    children: [children, args && (0, jsx_runtime_1.jsx)(Render, {
      renderer: renderer,
      args: args
    }, void 0)]
  }), void 0);
}

exports.ToastProvider = ToastProvider;

function _Toast(props, fwRef) {
  var _a = props.type,
      type = _a === void 0 ? 'info' : _a,
      other = __rest(props, ["type"]);

  return (0, jsx_runtime_1.jsx)(drawer_1.Drawer, __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &[data-notice-type='info'] {\n          background: var(--c-color-info);\n        }\n\n        &[data-notice-type='success'] {\n          background: var(--c-color-success);\n        }\n\n        &[data-notice-type='warning'] {\n          background: var(--c-color-warning);\n        }\n\n        &[data-notice-type='error'] {\n          background: var(--c-color-error);\n        }\n      "], ["\n        &[data-notice-type='info'] {\n          background: var(--c-color-info);\n        }\n\n        &[data-notice-type='success'] {\n          background: var(--c-color-success);\n        }\n\n        &[data-notice-type='warning'] {\n          background: var(--c-color-warning);\n        }\n\n        &[data-notice-type='error'] {\n          background: var(--c-color-error);\n        }\n      "]))),
    alignOffset: '20px',
    "data-notice-type": type,
    placement: 'bottom-center',
    ref: fwRef
  }, other), void 0);
}

exports.Toast = (0, react_2.forwardRef)(_Toast);
var templateObject_1;